module.exports = {
  DevMode: false,
  ApiUrl: {
    Dev: "http://localhost:5500",
    Prod: "",
  }
}